import gql from 'graphql-tag';

export default gql`
  mutation adminEditSchoolProfile($input: AdminEditSchoolProfileInput!) {
    adminEditSchoolProfile(input: $input) {
      id
    }
  }
`;
